// import React from 'react'
// import styles from "../../../src/asset/Skills/Skills.module.scss"

// const Skills = () => {
//   return (
//     <div>Skills</div>
//   )
// }

// export default Skills

import React from "react";
import styles from "../../../src/asset/Skills/Skills.module.scss"
import SkilsImage from "../../asset/homefour/front.webp"
import { useNavigate } from "react-router-dom";

const Skills = () => {

    const navigate = useNavigate();

  return (
    <section className={styles.skills}>
      {/* Top Section: Text */}
      <div className={styles.textBlock}>
        <h5>SKILLS & EXPERIENCE</h5>
        <h2>
          We design and develop <br /> innovative digital solutions
        </h2>
        <p>
          Our design scope covers camera-ready and embroidery-ready logos for
          corporate, team sports and club wear, vector design, embellished
          apparel, custom rhinestone designs, imprinted sportswear, applique,
          puff 3D designs, redraws and image editing.
        </p>
      </div>

      {/* Images Section */}
      <div className={styles.images}>
        <div className={styles.imageLeft}>
          <img src={SkilsImage} alt="Design on screens" />
          <div className={styles.overlayCard}>
            <h3>Ready to explore our design capabilities?</h3>
            <button             onClick={() => navigate("/service")}
 className={styles.btnhover}>Start here</button>
          </div>
        </div>
        {/* <div className={styles.imageRight}>
          <img src={SkilsImage} alt="Mobile design" />
        </div> */}
      </div>
    </section>
  );
};

export default Skills;
